interface Address {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zipCode: string;
}

export const Address = ({
  address1,
  address2,
  city,
  state,
  zipCode,
}: Address) => {
  return (
    <>
      <div>
        {address1}
        {address2 && `, ${address2}`}
      </div>{' '}
      <div>
        {city}, {state} {zipCode}
      </div>
    </>
  );
};
